import { ASYNC_START, LOGIN, REGISTER } from "../constants/actionTypes";

export default (state = {}, action) => {
    switch (action.type) {
    case LOGIN:
    case REGISTER:
        return {
            ...state,
            inProgress: false,
        };
    case ASYNC_START:
        if (action.subtype === LOGIN || action.subtype === REGISTER) {
            return { ...state, inProgress: true };
        }
        break;
    default:
        // nothing
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js